// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1E1T5","col":"styles_col__3a-z2"};